export enum PlaidEvent {
  CLOSE_OAUTH = 'CLOSE_OAUTH',
  ERROR = 'ERROR',
  EXIT = 'EXIT',
  FAIL_OAUTH = 'FAIL_OAUTH',
  HANDOFF = 'HANDOFF',
  MATCHED_SELECT_INSTITUTION = 'MATCHED_SELECT_INSTITUTION',
  MATCHED_SELECT_VERIFY_METHOD = 'MATCHED_SELECT_VERIFY_METHOD',
  OPEN = 'OPEN',
  OPEN_MY_PLAID = 'OPEN_MY_PLAID',
  OPEN_OAUTH = 'OPEN_OAUTH',
  SEARCH_INSTITUTION = 'SEARCH_INSTITUTION',
  SELECT_BRAND = 'SELECT_BRAND',
  SELECT_INSTITUTION = 'SELECT_INSTITUTION',
  SUBMIT_CREDENTIALS = 'SUBMIT_CREDENTIALS',
  SUBMIT_MFA = 'SUBMIT_MFA',
  TRANSITION_VIEW = 'TRANSITION_VIEW',
}

export enum PlaidAccount {
  CHECKING = 'checking',
  SAVINGS = 'savings',
}

export enum PlaidErrorCode {
  INVALID_LINK_TOKEN = 'INVALID_LINK_TOKEN',
}

export enum PlaidResponseCode {
  ERROR = -1,
  SUCCESS = 0,
  DISABLED = 1,
}
